import styled, { css } from 'styled-components';

import { scale005, xdlColorBorderSoft } from '@xing-com/tokens';

// *** Base ***
const baseDivider = css`
  background-color: ${xdlColorBorderSoft};
  border: none;
  height: ${scale005};
  margin: 0;
`;

// *** Components ***
export const Divider = styled.hr`
  ${baseDivider}
`;
